import React from 'react'
import { Box,Button, Paper, ButtonGroup, Tooltip } from '@mui/material'
import EmailEditorBlock from './blocks/EmailEditorBlock';
import useEmailEditorStore from '../utilities/emailEditorStore';
import { TextFields,Image,Description,DragHandle,Code,CheckBoxOutlineBlank,ViewColumn,SmartButton, Remove ,FormatListBulleted} from '@mui/icons-material';
function CanvasArea() {
     const {globalProperties,blocks,addBlock} = useEmailEditorStore();
   const getCanvasWidth = () => {
    switch (globalProperties.viewMode) {
      case 'mobile':
        return globalProperties.mobileBreakpoint;
      case 'desktop':
        return globalProperties.emailWidth;
      default:
        return globalProperties.emailWidth;
    }
  };
   const getCanvasStyles = () => {
    const baseStyles = {
      maxWidth: getCanvasWidth(),
      margin: '0 auto',
      minHeight: '500px',
      backgroundColor: globalProperties.backgroundColor,
      position: 'relative'
    };

    if (globalProperties.viewMode === 'preview') {
      return {
        ...baseStyles,
        border: 'none',
        boxShadow: 'none',
        borderRadius: 0
      };
    }

    return {
      ...baseStyles,
      border: '1px solid #e0e0e0',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      borderRadius: globalProperties.emailBorderRadius,
      padding: `${globalProperties.padding.top}px ${globalProperties.padding.right}px ${globalProperties.padding.bottom}px ${globalProperties.padding.left}px`,
      margin: `${globalProperties.margin.top}px auto ${globalProperties.margin.bottom}px auto`,
        
    };
  };
  return (
    <Box
      sx={{
        flex: 1,
        overflow: 'auto',
        minHeight: '90vh',
        p: globalProperties.viewMode === 'preview' ? 0 : 0,
        backgroundColor: globalProperties.viewMode === 'preview' ? 'white' : globalProperties.emailBackgroundColor
      }}
    
    >
          {/** Preheader text */}
          {globalProperties.preheaderText && (
            <div className="text-center">
                        <p className="text-gray-600">{globalProperties.preheaderText}</p>
            </div>
          )}
          

          <Paper sx={getCanvasStyles()} >
                 {blocks.map((block, index) => (
                    <EmailEditorBlock
                    key={index}
                    blockType={block.type}
                    blockProperties={block.properties}
                    blockId={block.id}
                    blockParentId= {block.parentId}
                    blockChildren={block.children}
                    />
                ))}

                  {blocks.length === 0 && (
                    <div className="text-center mt-10">
                        <p className="text-gray-500">Add Block to get started!</p>
                        </div>)
                  }
                <Box
                  sx = {{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    marginTop:5,
                    '& > *': {
                      m: 1,
                    },
                  }}
                >
                <ButtonGroup size="small" variant="outlined">
                    <Tooltip title="Heading" placement='bottom'>
                      <Button  onClick={() => addBlock('header', null, blocks.length)}>
                          <TextFields/>
                      </Button>
                    </Tooltip>
                    <Tooltip title="Text" placement='bottom'>
                    <Button  onClick={() => addBlock('text',null, blocks.length)}>
                            <Description/>
                    </Button>
                    </Tooltip>
                    <Tooltip title="Button" placement='bottom'>
                    <Button  onClick={() => addBlock('button', null, blocks.length)}>
                            <SmartButton/>
                    </Button>
                    </Tooltip>
                    <Tooltip title="List Items" placement='bottom'>
                    <Button  onClick={() => addBlock('listitems', null, blocks.length)}>
                            <FormatListBulleted/>
                    </Button>
                    </Tooltip>
                    <Tooltip title="Image" placement='bottom'>
                    <Button  onClick={() => addBlock('image', null, blocks.length)}>
                            <Image/>
                    </Button>
                    </Tooltip>
                    <Tooltip title="Spacing" placement='bottom'>
                     <Button  onClick={() => addBlock('spacer',null, blocks.length)}>
                           <DragHandle/>
                    </Button>
                    </Tooltip>
                    <Tooltip title="Divider Line" placement='bottom'>
                    <Button  onClick={() => addBlock('divider', null, blocks.length)}>
                           <Remove/>
                    </Button>
                    </Tooltip>
                    <Tooltip title="HTML code" placement='bottom'>
                    <Button  onClick={() => addBlock('htmlcontent', null, blocks.length)}>
                           <Code/>
                    </Button>
                    </Tooltip>
                    <Tooltip title="Container" placement='bottom'>
                    <Button  onClick={() => addBlock('container', null, blocks.length)}>
                           <CheckBoxOutlineBlank/>
                    </Button>
                    </Tooltip>
                    <Tooltip title="Column" placement='bottom'>
                    <Button  onClick={() => addBlock('columncontainer', null, blocks.length)}>
                           <ViewColumn/>
                    </Button>
                    </Tooltip>
                </ButtonGroup>
                 </Box>
               
          </Paper>
           {/** Footer text */}
          {globalProperties.footerText && (
            <div className="text-center mt-1">
                        <p className="text-gray-600">{globalProperties.footerText}</p>
            </div>
          )}
        </Box>
  )
}

export default CanvasArea